import authFetch from './fetch';
import { makeRequest } from './utils';

export const routes = {
  filterPath: (entityName) => `api/filters/${entityName}`,
  filterByIdPath: (entityName, filterId) => `api/filters/${entityName}/${filterId}`,
  filtersForCurrentUserPath: (entityName) => `api/filters/${entityName}/my`,
  filterFieldsPath: (entityName) => `api/filters/${entityName}/filterFields`,
};

export const addFilter = (filter, entityName) => makeRequest(
  authFetch.post(routes.filterPath(entityName), filter),
);
export const updateFilter = (id, filter, entityName) => makeRequest(
  authFetch.put(routes.filterByIdPath(entityName, id), filter),
);

export const getFilterById = (id, entityName) => makeRequest(authFetch.get(routes.filterByIdPath(entityName, id)));
export const deleteFilter = (id, entityName) => makeRequest(authFetch.delete(routes.filterByIdPath(entityName, id)));

export const getFiltersForCurrentUser = (entityName) => makeRequest(
  authFetch.get(routes.filtersForCurrentUserPath(entityName)),
);

export const getFilterFieldsForEntity = (entityName) => makeRequest(authFetch.get(routes.filterFieldsPath(entityName)));
